import logoPng from "@assets/grape-graph-logo-web.png";

interface LogoProps {
  className?: string;
  inverted?: boolean;
}

export default function Logo({ className = "h-10", inverted = false }: LogoProps) {
  return (
    <img 
      src={logoPng} 
      alt="GrapeGraph.ai Logo" 
      className={`${className} ${inverted ? "brightness-0 invert" : ""}`}
    />
  );
}
